import { render, staticRenderFns } from "./GalleryInputV2.vue?vue&type=template&id=68d98af1&scoped=true"
import script from "./GalleryInputV2.vue?vue&type=script&lang=ts"
export * from "./GalleryInputV2.vue?vue&type=script&lang=ts"
import style0 from "./GalleryInputV2.vue?vue&type=style&index=0&id=68d98af1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d98af1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VImg,VList,VListItem,VListItemContent,VListItemIcon})
